import React, { useState } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { BulbIcon } from "../../../../../constant/imagePath";
import classes from "./JustToNotifyYou.module.css";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { Button } from "../../../../../stories/Button/Button";

export default function JustToNotifyYou({ show, setShow }) {
  const [dontShow, setDontShow] = useState();

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      borderRadius={"20px"}
      modalClass={classes.modal}
      width={"368px"}
    >
      <div className={classes.modalContent}>
        <div className={classes.imgBox}>
          <img src={BulbIcon} className={classes.img} />
        </div>
        <h4
          style={{
            ...Fonts.h4,
            fontSize: "26px",
            color: Colors.neutralShadesOfNero,
          }}
        >
          Just to notify you
        </h4>
        <p
          style={{
            ...Fonts.p2,
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          If you skip required steps we wouldn’t be able to show your profile in
          our search results.
        </p>
        <p
          style={{
            ...Fonts.p2,
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          We care that our users get full information about coaches.
        </p>
        <p className={classes.separator}/>
        <Checkbox
            label="Don’t show this message again"
            setValue={setDontShow}
            value={dontShow}
          />
          <div className={classes.btnBox}>
            <Button
              label={"Got it"}
              primary={true}
              size={"Large"}
              onClick={() => setShow(false)}
            />
          </div>

        {/* <p
          className={classes.separator}
          style={{ borderBottomColor: Colors.neutralShadesOfGainsboro }}
        /> */}
      </div>
    </ModalSkeleton>
  );
}
